export function ggDecimal($filter) {
  return function (input, places) {
    if (isNaN(input)) return input;
    // If we want 1 decimal place, we want to mult/div by 10
    // If we want 2 decimal places, we want to mult/div by 100, etc
    // So use the following to create that factor
    var factor = "1" + Array(+(places > 0 && places + 1)).join("0");
    return Math.round(input * factor) / factor;
  };
}

export function ggUnit($filter) {
  return function (input, mesSystem, unit, unit_si) {

    if (mesSystem === 'SI') return input + ' ' + unit_si;else
    return input + ' ' + unit;
    /*
                               if (isNaN(input))
                                 if (mesSystem == 'US') return input + ' ' + unit;
                                 else return input + ' ' + unit_si;
                                var unit_si2 = unit_si;
                               var unit2 = unit;
                               var input2 = parseFloat(input);
                                if (input2 < 15) input2 = (Math.round(input * 10) / 10).toFixed(1).replace(/[.,]0$/, "");
                               else if (input2 >= 15 && input2 < 50) input2 = Math.round(input / 5) * 5;
                               else if (input2 >= 50 &&  input2 < 150) input2 = Math.round(input / 10) * 10;
                               else if (input2 >= 150 && input2 < 500) {
                                 input2 = Math.round(input / 50) * 50;
                                 if (input2 == 500) {
                                   input2 = 0.5;
                                   if (unit_si === 'ml') unit_si2 = 'l';
                                   else if (unit_si === 'g') unit_si2 = 'kg';
                                 }
                               }
                               else if (input2 >= 500 && mesSystem === 'SI' && (unit_si === 'ml' || unit_si === 'g')) {
                                 input2 = Math.round(input / 100) / 10;
                                 if (unit_si === 'ml') unit_si2 = 'l';
                                 else if (unit_si === 'g') unit_si2 = 'kg';
                               }
                               else if  (input2 >= 500) input2 = Math.round(input / 100) * 100;
                                if (mesSystem === 'SI') return input2 + ' ' + unit_si2;
                               else return input2 + ' ' + unit2;
                               */



  };
}

export function relativeDate($filter) {
  return function (rel) {
    var date = new Date();
    date.setDate(date.getDate() + rel);
    return $filter('date')(date, 'EEEE, MMM, d, y');
  };
}